<template>
<div class="row">
  <div class="col-lg-12">
    <h1>Edit Survey</h1>
    <div class="qm-panel">
      <form v-on:change="saveSurvey">
        <div class="form-group row">
          <label for="accountName" class="col-5 col-form-label">Account Name</label>
          <div class="col-7">
            <input id="accountName" v-model="survey.accountName" type="text" class="form-control" disabled="disabled">
          </div>
        </div>
        <div class="form-group row">
          <label for="clientLastName" class="col-5 col-form-label">Client Lastname</label>
          <div class="col-7">
            <input id="clientLastName" v-model="survey.clientLastName" type="text" class="form-control" disabled="disabled">
          </div>
        </div>
        <div class="form-group row">
          <label for="clientFirstName" class="col-5 col-form-label">Client Firstname</label>
          <div class="col-7">
            <input id="clientFirstName" v-model="survey.clientFirstName" type="text" class="form-control" disabled="disabled">
          </div>
        </div>
        <div class="form-group row">
          <label for="surveyor" class="col-5 col-form-label">Surveyor</label>
          <div class="col-7">
            <input id="surveyor" v-model="survey.surveyor" type="text" class="form-control" disabled="disabled">
          </div>
        </div>
        <div class="form-group row">
          <label for="surveyDate" class="col-5 col-form-label">Survey Date</label>
          <div class="col-7">
            <input id="surveyDate" v-model="survey.surveyDate" type="date" class="form-control qm-date-field" disabled="disabled">
          </div>
        </div>
        <div class="form-group row">
          <label for="surveyTimeStart" class="col-5 col-form-label">Survey Time</label>
          <div class="col-7">
            <input id="surveyTimeStart" v-model="survey.surveyTime" type="time" class="form-control qm-time-field" disabled="disabled">
          </div>
        </div>
        <hr />
        <div class="form-group row">
          <label for="address-01" class="col-5 col-form-label">Address 1</label>
          <div class="col-7">
            <input id="address-01" v-model="survey['address-01']" type="text" class="form-control">
          </div>
        </div>
        <div class="form-group row">
          <label for="address-02" class="col-5 col-form-label">Address 2</label>
          <div class="col-7">
            <input id="address-02" v-model="survey['address-02']" type="text" class="form-control">
          </div>
        </div>
        <div class="form-group row">
          <label for="address-03" class="col-5 col-form-label">Address 3</label>
          <div class="col-7">
            <input id="address-03" v-model="survey['address-03']" type="text" class="form-control">
          </div>
        </div>
        <div class="form-group row">
          <label for="address-04" class="col-5 col-form-label">Address 4</label>
          <div class="col-7">
            <input id="address-04" v-model="survey['address-04']" type="text" class="form-control">
          </div>
        </div>
        <div class="form-group row">
          <label for="postcode" class="col-5 col-form-label">Postcode</label>
          <div class="col-7">
            <input id="postcode" v-model="survey.postcode" type="text" class="form-control">
          </div>
        </div>
        <div class="form-group row">
          <label for="city" class="col-5 col-form-label">City</label>
          <div class="col-7">
            <input id="city" v-model="survey.city" type="text" class="form-control">
          </div>
        </div>
        <div class="form-group row">
          <label class="col-5 col-form-label" for="qm-survey-country-select">Country</label>
          <div class="col-7">
            <select v-model="selectedCountry" v-on:change="updateCountry" class="custom-select" name="qm-survey-country-select" id="qm-survey-country-select">
              <option v-for="country in nationalityOptions" v-bind:value="country.id">{{ country.text }}</option>
            </select>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-5 col-form-label" for="qm-survey-parking-reservation-checkbox">Parking</label>
          <div class="col-7">
              <label>
                  <input v-model="survey.parkingReservation" type="checkbox" class="form-check-input">
                  Parking reservation
              </label>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-5 col-form-label" for="qm-survey-outside-elevator-checkbox">Elevator</label>
          <div class="col-7">
              <label>
                  <input v-model="survey.outsideElevator" type="checkbox" class="form-check-input">
                  Outside Elevator
              </label>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-5 col-form-label" for="qm-survey-language-select">Client Language</label>
          <div class="col-7">
            <select v-model="selectedLanguage" v-on:change="updateLanguage" class="custom-select qm-time-field" name="qm-survey-language-select" id="qm-survey-language-select">
              <option v-for="language in languageOptions" v-bind:value="language">{{ language }}</option>
            </select>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-5 col-form-label" for="qm-survey-nationality-select">Client Nationality</label>
          <div class="col-7">
            <select v-model="selectedNationality" v-on:change="updateNationality" class="custom-select" name="qm-survey-language-select" id="qm-survey-nationality-select">
              <option v-for="nationality in nationalityOptions" v-bind:value="nationality.id">{{ nationality.text }}</option>
            </select>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-5 col-form-label" for="qm-survey-default-mode-select">Default Mode</label>
          <div class="col-7">
            <select v-model="selectedDefaultMode" v-on:change="updateDefaultMode" class="custom-select" name="qm-survey-default-mode-select" id="qm-survey-default-mode-select">
              <option v-for="mode in modesOptions" v-bind:value="mode.id">{{ mode.text }}</option>
            </select>
          </div>
        </div>
        <div class="form-group row">
          <label for="movingDates" class="col-5 col-form-label">Moving Dates</label>
          <div class="col-7">
            <textarea id="movingDates" v-model="survey.movingDates" class="form-control" rows="3"></textarea>
          </div>
        </div>
        <div class="form-group row">
          <label for="travelPlans" class="col-5 col-form-label">Travel Plans</label>
          <div class="col-7">
            <textarea id="travelPlans" v-model="survey.travelPlans" class="form-control" rows="3"></textarea>
          </div>
        </div>
        <div class="form-group row">
          <label for="notes" class="col-5 col-form-label">Notes</label>
          <div class="col-7">
            <textarea id="notes" v-model="survey.notes" class="form-control" rows="15"></textarea>
          </div>
        </div>
        <div class="row mt-5">
          <div class="col-6">
            <h2>Services</h2>
            <div class="form-check">
              <label class="form-check-label">
                <input class="form-check-input" type="checkbox" v-model="survey.packfragiles">
                Pack fragiles only
              </label>
            </div>
            <div class="form-check">
              <label class="form-check-label">
                <input class="form-check-input" type="checkbox" v-model="survey.packsmalls">
                Pack all smalls
              </label>
            </div>
            <div class="form-check">
              <label class="form-check-label">
                <input class="form-check-input" type="checkbox" v-model="survey.fullpacking">
                Full packing
              </label>
            </div>
            <hr>
            <div class="form-check">
              <label class="form-check-label">
                <input class="form-check-input" type="checkbox" v-model="survey.disassembly">
                Disassembly
              </label>
            </div>
            <div class="form-check">
              <label class="form-check-label">
                <input class="form-check-input" type="checkbox" v-model="survey.blanketwrap">
                Blanket wrap
              </label>
            </div>
            <div class="form-check">
              <label class="form-check-label">
                <input class="form-check-input" type="checkbox" v-model="survey.exportwrap">
                Full export wrap
              </label>
            </div>
            <hr>
            <div class="form-check">
              <label class="form-check-label">
                <input class="form-check-input" type="checkbox" v-model="survey.unpackfragiles">
                Unpack fragiles
              </label>
            </div>
            <div class="form-check">
              <label class="form-check-label">
                <input class="form-check-input" type="checkbox" v-model="survey.unpacksmalls">
                Unpack all smalls
              </label>
            </div>
            <div class="form-check">
              <label class="form-check-label">
                <input class="form-check-input" type="checkbox" v-model="survey.fullunpacking">
                Full unpacking
              </label>
            </div>
            <hr>
            <div class="form-check">
              <label class="form-check-label">
                <input class="form-check-input" type="checkbox" v-model="survey.assembly">
                Reassembly
              </label>
            </div>
            <div class="form-check">
              <label class="form-check-label">
                <input class="form-check-input" type="checkbox" v-model="survey.blanketunwrap">
                Blanket unwrapping
              </label>
            </div>
            <div class="form-check">
              <label class="form-check-label">
                <input class="form-check-input" type="checkbox" v-model="survey.exportunwrap">
                Full unwrapping
              </label>
            </div>
          </div>
          <div class="col-6">
            <h2>Special remarks</h2>
            <div class="form-check">
              <label class="form-check-label">
                <input class="form-check-input" type="checkbox" v-model="survey.englishcrew">
                Engl. speaking crew
              </label>
            </div>
            <div class="form-check">
              <label class="form-check-label">
                <input class="form-check-input" type="checkbox" v-model="survey.relodeparture">
                Relo Departure
              </label>
            </div>
            <div class="form-check">
              <label class="form-check-label">
                <input class="form-check-input" type="checkbox" v-model="survey.relodestination">
                Relo Destination
              </label>
            </div>
            <hr>
            <div class="form-check">
              <label class="form-check-label">
                <input class="form-check-input" type="checkbox" v-model="survey.pet">
                Pet
              </label>
            </div>
            <div class="form-check">
              <label class="form-check-label">
                <input class="form-check-input" type="checkbox" v-model="survey.car">
                Car
              </label>
            </div>
            <div class="form-check">
              <label class="form-check-label">
                <input class="form-check-input" type="checkbox" v-model="survey.motorbike">
                Motorbike
              </label>
            </div>
            <hr>
            <div class="form-check">
              <label class="form-check-label">
                <input class="form-check-input" type="checkbox" v-model="survey.electrician">
                Electrician
              </label>
            </div>
            <div class="form-check">
              <label class="form-check-label">
                <input class="form-check-input" type="checkbox" v-model="survey.carpenter">
                Carpenter
              </label>
            </div>
            <div class="form-check">
              <label class="form-check-label">
                <input class="form-check-input" type="checkbox" v-model="survey.plumber">
                Plumber
              </label>
            </div>
            <hr>
            <div class="form-check">
              <label class="form-check-label">
                <input class="form-check-input" type="checkbox" v-model="survey.cleaning">
                Cleaning
              </label>
            </div>
            <div class="form-check">
              <label class="form-check-label">
                <input class="form-check-input" type="checkbox" v-model="survey.plants">
                Plants
              </label>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="qm-panel">
      <h2>Photos</h2>
      <foto-list :mode="'survey'" :maxFotos="50"></foto-list>
    </div>
  </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import FotoList from './children/FotoList.vue'
export default {
  name: 'SurveyDetail',
  components: {
    'foto-list': FotoList
  },
  data: () => ({
    languageOptions: [],
    selectedLanguage: '',
    selectedNationality: null,
    selectedCountry: null,
    selectedDefaultMode: null
  }),
  computed: {

    ...mapGetters({
      session: 'getSession',
      survey: 'getSurvey',
      nationalityOptions: 'allCountries',
      modesOptions: 'getAllModes'
    }),
    surveyId () {
      return this.session.surveyId
    }
  },
  created: function () {
    // set language options from config
    this.languageOptions = this.$getLanguages()
    this.selectedLanguage = this.languageOptions[0]
    this.$store.dispatch('loadSession').then(() => {
      this.$store.dispatch('getSurveyById', this.session.surveyId).then(() => {
        if (this.survey.clientLanguage !== null) {
          this.selectedLanguage = this.survey.clientLanguage
        }
        this.$store.dispatch('loadAllCountries').then(() => {
          this.selectedNationality = this.survey.clientNationality
          this.selectedCountry = this.survey.country
        })
        this.$store.dispatch('loadAllModes').then(() => {
          if (!!this.survey.defaultMode && this.survey.defaultMode !== null) {
            this.selectedDefaultMode = this.survey.defaultMode
          }
        })
      })
    })
  },
  methods: {
    updateLanguage () {
      this.survey.surveyLanguage = this.selectedLanguage
      this.survey.clientLanguage = this.selectedLanguage
    },
    updateNationality () {
      this.survey.clientNationality = this.selectedNationality
    },
    updateCountry () {
      this.survey.country = this.selectedCountry
    },
    updateDefaultMode () {
      this.survey.defaultMode = this.selectedDefaultMode
    },
    saveSurvey () {
      this.$store.dispatch('updateSurvey', this.survey)
    }
  }
}
</script>

<style scoped>
  .col-7 .form-check-input {
    margin-left: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/SurveyDetail.vue